import React from "react";
import { Card } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 230,
      height: 54,
      display: "flex",
      flex: 1,
      fill: "white",
    },
    firstSection: {
      backgroundColor: theme.palette.primary.main,
      display: "flex",
      justifyContent: "center",
      justifyItems: "center",
      height: 54,
      width: 54,
    },
    iconContent: {
      marginTop: "auto",
      marginBottom: "auto",
    },
    icon: {
      height: 24,
      width: 24,
    },
    secondSection: {
      display: "flex",
      fontSize: 14,
      textTransform: "capitalize",
      height: 54,
    },
    content: {
      marginTop: "auto",
      marginBottom: "auto",
      display: "flex",
    },
    title: {
      color: theme.palette.primary.main,
      marginLeft: 20,
      paddingRight: 1,
    },
    text: {
      paddingRight: 20,
      paddingLeft: 1,
    },
  })
);
export interface SmallCardProps {
  flexDirection?: "column" | "row";
  width?: number;
  height?: number;
  title: string;
  text: string;
  icon: React.ReactElement | null;
  fontSize?: number;
}
export function SmallCard({
  width = 230,
  height = 54,
  flexDirection = "column",
  title,
  text,
  icon,
  fontSize = 14,
}: SmallCardProps) {
  const styles = useStyles();
  return (
    <Card
      className={styles.root}
      style={{
        width,
        height,
      }}
    >
      <div
        className={styles.firstSection}
        style={{
          height,
          width: height,
        }}
      >
        <div className={styles.iconContent}>{icon}</div>
      </div>
      <div
        className={styles.secondSection}
        style={{
          fontSize,
          width: height - width,
        }}
      >
        <div
          className={styles.content}
          style={{
            flexDirection,
          }}
        >
          <div
            className={styles.title}
            style={{
              paddingRight: flexDirection === "column" ? 20 : 0,
            }}
          >
            {title}:
          </div>
          <div
            className={styles.text}
            style={{
              paddingLeft: flexDirection === "column" ? 20 : 2,
            }}
          >
            {text}
          </div>
        </div>
      </div>
    </Card>
  );
}
